import React from "react";
import { ShieldCheck, Clock, MapPinned, Handshake } from "lucide-react";
import { WHY_IMG } from "../../lib/site";

const POINTS = [
  {
    icon: Clock,
    title: "Same-Day & 24/7 Emergency",
    text: "Water, storm or fire damage? We respond same-day, any time, to get your home back fast.",
  },
  {
    icon: MapPinned,
    title: "Truly Local",
    text: "Based in Blairsville, GA and serving a 50-mile radius across North GA and Murphy, NC.",
  },
  {
    icon: Handshake,
    title: "Honest, Fair Pricing",
    text: "Free estimates and straight talk. We recommend what your home actually needs — nothing more.",
  },
];

export const WhyChooseUs = () => {
  return (
    <section id="why" data-testid="why-section" className="py-20 md:py-28 bg-[#0E2A56]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <p className="font-heading font-bold uppercase tracking-[0.2em] text-[#C8102E] text-sm">
            Why Choose Journey's
          </p>
          <h2 className="mt-2 font-heading text-4xl sm:text-5xl font-extrabold uppercase tracking-tight text-white">
            The Handyman North Georgia Trusts
          </h2>
          <p className="mt-4 text-lg text-white/80 font-medium max-w-xl">
            Reliable, professional handyman services with the workmanship of a contractor
            and the friendliness of a neighbor.
          </p>

          <div className="mt-10 grid sm:grid-cols-2 gap-6">
            {POINTS.map((p) => {
              const Icon = p.icon;
              return (
                <div key={p.title} data-testid={`why-point-${p.title.split(" ")[0].toLowerCase()}`} className="border-l-2 border-[#C8102E] pl-4">
                  <span className="inline-flex h-11 w-11 items-center justify-center bg-[#C8102E] text-white mb-3">
                    <Icon className="h-6 w-6" strokeWidth={2.5} />
                  </span>
                  <h3 className="font-heading text-xl font-bold uppercase tracking-tight text-white">
                    {p.title}
                  </h3>
                  <p className="mt-1 text-white/70 text-sm leading-relaxed">{p.text}</p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="relative">
          <img
            src={WHY_IMG}
            alt="Journey's Handyman painter staining a wood plank ceiling in North Georgia"
            className="w-full h-[520px] object-cover border-4 border-white shadow-hard-red"
          />
        </div>
      </div>
    </section>
  );
};
